import { computed } from "vue";

export default {
  name: "ProductDropdown",
  props: {
    productNode: {
      type: Object,
      required: true,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    isOrdered: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    isHeaderLine: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  setup(props, { emit }) {
    const product = computed(() => props.productNode.value);
    const children = computed(() => props.productNode.getOffspring());
    const handleChange = (e) => {
      // also support <select multiple>
      const productId =
        e.target instanceof HTMLSelectElement && e.target.multiple
          ? [...e.target.options].filter((option) => option.selected).map((option) => option.value || option.text)
          : e.target.value;
      emit("change", productId);
    };
    const isSelected = (id) => props.selectedIds.includes(id);

    return {
      product,
      children,
      isSelected,
      handleChange,
    };
  },
};
